var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrehen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Drehen__Icn/40px/Drehen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Drehen__Icn/40px/Plus-Tools",
    transform: "matrix(-1 0 0 1 40 0)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Drehen__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,9.66632952 C28.642669,9.66632952 35.7959252,14.0191805 35.9957109,19.7074519 L36,19.9520438 L34,19.9520438 C34,15.5029348 27.8024068,11.6663295 20,11.6663295 C16.3249081,11.6663295 12.8911568,12.5244662 10.3157297,14.0000114 L13,14 L13,16 L6.07692308,16 L6.07692308,10.7142857 L8.07692308,10.7142857 L8.07525018,13.0633295 L8.19442459,12.9781595 C11.1958482,10.8797347 15.4476206,9.66632952 20,9.66632952 Z M6.01225018,20.0806882 C6.01225018,24.5297972 12.2098433,28.3664025 20.0122502,28.3664025 C23.7139927,28.3664025 27.1708818,27.4957749 29.7524135,26.0005227 L27.0769231,26 L27.0769231,24 L34,24 L34,29.2857143 L32,29.2857143 L31.9992502,26.9233295 L31.8178256,27.0545725 C28.816402,29.1529973 24.5646296,30.3664025 20.0122502,30.3664025 C11.3695812,30.3664025 4.21632496,26.0135515 4.01653926,20.3252801 L4.01225018,20.0806882 L6.01225018,20.0806882 Z",
    id: ".._.._src_svg_Icn_40px_Drehen__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrehen);
export default __webpack_public_path__ + "static/media/Drehen.9ef64e8cab277ae35941425421e7df87.svg";
export { ForwardRef as ReactComponent };